<template>
  <div>
    <!--  版本信息确认  -->
    <release-review-version-confirm @getVersionData="getVersionData"/>
    <el-divider></el-divider>
    <div>
      <releaseReviewItem preset="肝脏" mode="B模式" @getReviewData="getLiverB"/>
      <releaseReviewItem preset="肝脏" mode="C模式" @getReviewData="getLiverC"/>
      <releaseReviewItem preset="肝肾切面" mode="B模式" @getReviewData="getLkB"/>
      <releaseReviewItem preset="腹主动脉" mode="B模式" @getReviewData="getAAB"/>
      <releaseReviewItem preset="腹主动脉" mode="C模式" @getReviewData="getAAC"/>
      <releaseReviewItem preset="下腔静脉" mode="B模式" @getReviewData="getIVCB"/>
      <releaseReviewItem preset="下腔静脉" mode="C模式" @getReviewData="getIVCC"/>
      <releaseReviewItem preset="胆囊" mode="B模式" @getReviewData="getGBB"/>
      <releaseReviewItem preset="肾脏" mode="B模式" @getReviewData="getKidneyB"/>
      <releaseReviewItem preset="肾脏" mode="C模式" @getReviewData="getKidneyC"/>
      <releaseReviewItem preset="其他" mode="" @getReviewData="getOther"/>
    </div>
  </div>
</template>

<script>
import ReleaseReviewItem from "./ReleaseReviewItem";
import ReleaseReviewVersionConfirm from "./ReleaseReviewVersionConfirm";

export default {
  name: "ReleaseReviewForConvex",
  components: {
    ReleaseReviewItem,
    ReleaseReviewVersionConfirm
  },
  data() {
    return {
      convex: {
        liver_b_opinion: '',
        liver_b_images: [],
        liver_c_opinion: '',
        liver_c_images: [],
        lk_b_opinion: '',
        lk_b_images: [],
        aa_b_opinion: '',
        aa_b_images: [],
        aa_c_opinion: '',
        aa_c_images: [],
        ivc_b_opinion: '',
        ivc_b_images: [],
        ivc_c_opinion: '',
        ivc_c_images: [],
        gb_b_opinion: '',
        gb_b_images: [],
        kidney_b_opinion: '',
        kidney_b_images: [],
        kidney_c_opinion: '',
        kidney_c_images: [],
        version_confirm: '',
        other_opinion: '',
        other_images: []
      }
    }
  },
  watch: {
    convex: {
      handler: function (val){
        this.sendConvexData(val);
      },
      deep: true
    }
  },
  methods: {
    // 发送最新凸阵数据给父路由
    sendConvexData(data) {
      this.$emit('getConvexData', this.convex);
    },
    // 得到肝脏B模式的调用
    getLiverB(data) {
      this.convex.liver_b_opinion = data.opinion;
      this.convex.liver_b_images = data.fileList;
    },
    // 得到肝脏C模式的反馈调用
    getLiverC(data) {
      this.convex.liver_c_opinion = data.opinion;
      this.convex.liver_c_images = data.fileList;
    },
    // 得到肝肾切面B模式的反馈调用
    getLkB(data) {
      this.convex.lk_b_opinion = data.opinion;
      this.convex.lk_b_images = data.fileList;
    },
    // 得到腹主动脉B模式的反馈调用
    getAAB(data) {
      this.convex.aa_b_opinion = data.opinion;
      this.convex.aa_b_images = data.fileList;
    },
    // 得到腹主动脉C模式的反馈调用
    getAAC(data) {
      this.convex.aa_c_opinion = data.opinion;
      this.convex.aa_c_images = data.fileList;
    },
    // 得到下腔静脉B模式的反馈调用
    getIVCB(data) {
      this.convex.ivc_b_opinion = data.opinion;
      this.convex.ivc_b_images = data.fileList;
    },
    // 得到下腔静脉C模式长轴的反馈调用
    getIVCC(data) {
      this.convex.ivc_c_opinion = data.opinion;
      this.convex.ivc_c_images = data.fileList;
    },
    // 得到胆囊B模式长轴的反馈调用
    getGBB(data) {
      this.convex.gb_b_opinion = data.opinion;
      this.convex.gb_b_images = data.fileList;
    },
    // 得到肾脏B模式短轴的反馈调用
    getKidneyB(data) {
      this.convex.kidney_b_opinion = data.opinion;
      this.convex.kidney_b_images = data.fileList;
    },
    // 得到肾脏C模式短轴的反馈调用
    getKidneyC(data) {
      this.convex.kidney_c_opinion = data.opinion;
      this.convex.kidney_c_images = data.fileList;
    },
    // 得到其他反馈调用
    getOther(data) {
      this.convex.other_opinion = data.opinion;
      this.convex.other_images = data.fileList;
    },
    // 得到用户的信息
    getInfoData(data) {
      this.formInline.name = data.name;
      this.formInline.phone = data.phone;
      this.formInline.probeSn = data.probeSn;
      this.formInline.probeType = data.probeType;
    },
    // 得到测试版本信息
    getVersionData(data) {
      this.convex.version_confirm = data;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/release_review/ReleaseReviewForConvex.vue